
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';
import { Wait } from '@/__env/ext';
import { Oferta } from '@/__env/lib/Articulos/Articulo.lib';
import { Llamado } from '@/__env/lib/Turnero/Turnero.lib';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get ControladorTurnero() { return this.Controlador.Turnero; }
        public get Turnero() { return this.Controlador.Turnero.Turnero; }

        public Modo: string = '';
        public Estado: string = '';
        public Cambiando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {

            this.Estado = this.ControladorTurnero.Vista.Estado;
            this.Modo = this.ControladorTurnero.Vista.Modo;
            this.Eventos.push( this.ControladorTurnero.onActualizar.subscribe( () => this.Refrescar() ) );
            this.Eventos.push( this.ControladorTurnero.Vista.onEstado.subscribe( () => this.Estado = this.ControladorTurnero.Vista.Estado ) );
            this.Eventos.push( this.ControladorTurnero.Vista.onModo.subscribe( () => this.Modo = this.ControladorTurnero.Vista.Modo ) );

        }


        public HayLlamados() { return this.Turnero.Llamados.hasRows(); }
        public Ultimo()
        {
            if ( this.Turnero.Llamados.hasRows() )
                return this.Turnero.Llamados[0];
        }
        public Ultimos()
        {
            let e: Llamado[] = [];
            for ( var i = 0; i < this.Turnero.Llamados.length; i++ )
            {
                if ( e.length == 6 )
                    break;
                if ( i != 0 )
                {
                    e.push( this.Turnero.Llamados[i] );
                }
            }
            return e;
        }

        public Refresh: boolean = true;
        Refrescar()
        {

            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }



    }
